import { WEB_COMPONENT_EASM_RELATED_FINDINGS } from '../../webcomponents.constants';
import EasmRelatedFindingsWebComponent from './component/EasmRelatedFindingsWebComponent';

export { EasmRelatedFindingsWebComponent };

window.customElements.define(WEB_COMPONENT_EASM_RELATED_FINDINGS, EasmRelatedFindingsWebComponent);
